// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oj-1";
export var messageSideRight = "_oj-2";
export var subscribeToBackInStockBubbleContainer = "_oj-0";